import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__copyright">
          <div className="row">
            <div className="col-lg-12">
              <p className="footer__copyright__text">
                Copyright © {currentYear}-{nextYear} All Rights Reserved | iBullz
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};


export default Footer;
